import type { EdgeLambdaApiError } from './cors-edge-lambda-api';

/** Extract a user-facing detail string from an edge-lambda upload error body. */
export function formatUploadErrorDetail(error: EdgeLambdaApiError): string | null {
  if (!error.detail) return null;
  try {
    const parsed = JSON.parse(error.detail) as { detail?: unknown };
    if (typeof parsed.detail === 'string' && parsed.detail.trim() !== '') {
      return parsed.detail.trim();
    }
  } catch {
    // Plain-text upstream body (e.g. S3 XML).
  }
  const trimmed = error.detail.trim();
  return trimmed.length > 0 && trimmed.length <= 240 ? trimmed : null;
}
